import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavigationEvent } from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-common-carouselnav',
  templateUrl: './carousel-nav.component.html',
  styleUrls: ['./carousel-nav.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, RouterLink, AngularSvgIconModule],
})
export class CarouselNavComponent implements OnInit {
  @Input() classPrev: string = 'nextEl'; // Switch value
  @Input() classNext: string = 'prevEl'; // Switch value
  @Input() position: 'side' | 'top' = 'side'; // position
  @Input() navigationEvent!: NavigationEvent;

  @Output() paginationEvent = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  navigation(type: string) {
    this.paginationEvent.emit(type);
  }
}
